import React from "react";

import Text from "src/components/text";

import styles from "./styles.module.scss";
import { User } from "src/types/users";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface TopSharersCardItem {
  user: User;
  analytics: Analytics;
}

export interface TopSharersCardProps {
  item: TopSharersCardItem;
}

export const TopSharersCard: React.FC<TopSharersCardProps> = ({ item }) => {
  const { user, analytics } = item;
  return (
    <div className={styles.card}>
      <img
        src={user.icon?.thumbnail || DefaultAssetIcon}
        className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
        alt={`${user.firstName} ${user.lastName}`}
      />
      <div className={styles.content}>
        <Text
          lines={1}
          className={styles.title}
          text={`${user.firstName} ${user.lastName}`}
        />
        <div className={styles.metrics}>
          <span>{analytics.shares || 0} Shares</span>
          <span>{analytics.assets || 0} Assets</span>
        </div>
      </div>
    </div>
  );
};
